export const MAXIMUM_NUMBER_TERMS = 3;
export const MINIMUM_NUMBER_TERMS = 0;

export const CHECKBOX_MAP_TO_ELEMENT_TEXT = {
  agreeAllBellow: 'Agree to all',
  agreeLegalAge: 'Age, reviewed, and agree',
  agreeCollectPersonalInfo: 'PI collection consent',
  agreeProvisionToThirds: 'PI provision consent',
};
